import { GetData, GetDataV2 } from "./Functions/SettingData";
import qs from "qs";

export const getDataImports = async (filters = {}) => {
  var config = {
    method: "get",
    url: `/api/dataimports`,
    headers: {
      "Content-Type": "application/json",
    },
    params: filters,
    paramsSerializer: (params) =>
      qs.stringify(params, { arrayFormat: "repeat" }),
  };

  let data = await GetData(config);
  return data;
};

export const getDataImportTypes = async () => {
  var config = {
    method: "get",
    url: `/api/dataimports/types`,
    headers: {
      "Content-Type": "application/json",
    },
  };

  let data = await GetData(config);
  return data;
};

export const dataImport = async (importType, file) => {
  // Create FormData to send file and importType
  const formData = new FormData();
  formData.append("dataImportType", importType);
  formData.append("file", file);

  var config = {
    method: "post",
    url: `/api/dataimports`,
    headers: {
      "Content-Type": "multipart/form-data",
    },
    data: formData,
  };

  let data = await GetData(config);
  return data;
};

export const dataImportValidate = async (importUUID) => {
  var config = {
    method: "post",
    url: `/api/dataimports/${importUUID}/validate`,
    headers: {
      "Content-Type": "application/json",
    },
    paramsSerializer: (params) =>
      qs.stringify(params, { arrayFormat: "repeat" }),
  };

  let data = await GetData(config);
  return data;
};

export const dataImportConfirmUpload = async (importUUID, userRemarks) => {
  var config = {
    method: "post",
    url: `/api/dataimports/${importUUID}/final_import`,
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      userRemarks: userRemarks,
    },
  };

  let data = await GetData(config);
  return data;
};

export const deleteDataImport = async (importUUID) => {
  var config = {
    method: "delete",
    url: `/api/dataimports/${importUUID}`,
    headers: {
      "Content-Type": "application/json",
    },
    paramsSerializer: (params) =>
      qs.stringify(params, { arrayFormat: "repeat" }),
  };

  let data = await GetData(config);
  return data;
};

export const downloadFullReport = async (importUUID) => {
  var config = {
    method: "get",
    url: `/api/dataimports/${importUUID}/full_report`,
    headers: {
      "Content-Type": "application/json",
    },
    responseType: "blob",
    paramsSerializer: (params) =>
      qs.stringify(params, { arrayFormat: "repeat" }),
  };

  let data = await GetDataV2(config);
  return data;
};

export const downloadErrorReport = async (importUUID) => {
  var config = {
    method: "get",
    url: `/api/dataimports/${importUUID}/error_report`,
    headers: {
      "Content-Type": "application/json",
    },
    responseType: "blob",
    paramsSerializer: (params) =>
      qs.stringify(params, { arrayFormat: "repeat" }),
  };

  let data = await GetDataV2(config);
  return data;
};
